<template>
  <svg viewBox="0 0 1800 300" preserveAspectRatio="xMidYMid meet" style="width: 80vw; height: auto;">
    <defs>
      <!-- Adjusted path coordinates for a curvier curve -->
      <!-- d="
            M 0,300 
            A 200,200 0 0 1 400,300" -->
      <path id="line1" d="M 0,300 
            A 200,200 0 0 1 600,300" />     
             <path id="line2" d="M -100,250 
            A 300,150 0 0 1 700,300" />
    </defs>
    <text fill="white"  class="asimovian-regular">
      <textPath startOffset="50%" href="#line1" dominant-baseline="middle" text-anchor="middle">
        <slot></slot>
      </textPath>      
      <textPath startOffset="50%" href="#line2" dominant-baseline="middle" text-anchor="middle">
        <slot></slot>
      </textPath>
    </text>
  </svg>
</template>


<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
svg {
    overflow: visible;
    display: block;
    position: absolute;
    top: 10%;
    left: 40vw;
    transform: translate(-17%, 50%);
}

svg text {
  text-anchor: middle;
  offset: 50%;
  fill:white;
  font-size: 5rem;
}
textPath{
  font-family: "Asimovian", sans-serif;
  font-weight: 400;
  font-style: normal;
}
textPath[xlink\:href="#line2"],
textPath[href="#line2"] 
{
  display: none !important;
}
@media (max-width: 1050px) {
svg {
  left: 49%;
}
svg text {

  font-size: 8rem;
}
textPath[xlink\:href="#line1"],
textPath[href="#line1"] 
{
  display: none !important;
}
textPath[xlink\:href="#line2"],
textPath[href="#line2"] 
{
  display: unset !important;
}
}



</style>
